import {
  PAYMENT_METHODS,
  AVAILABLE_CURRENCIES,
  SERVICE_TYPE,
} from "@typings/globals";
import { PAYMENT_STATUS } from "@typings/payments";
import { CLEANING_FREQUENCY } from "@typings/booking";

export const BOOKING_FUNNEL_VIEW = "booking-funnel-view" as const;
export enum FUNNEL_STEP {
  CLEANING_INFORMATION = "cleaning-information",
  CHECKOUT = "checkout",
  PAYMENT = "payment",
  PURCHASE = "purchase",
}

export interface CleaningInformationDL {
  funnelStep: FUNNEL_STEP.CLEANING_INFORMATION;
  cleaningType: SERVICE_TYPE.HOME_CLEANING;
  locationId: number;
  userIdSHA256: string | "";
}

export interface CheckoutDL {
  funnelStep: FUNNEL_STEP.CHECKOUT;
  cleaningType: SERVICE_TYPE.HOME_CLEANING;
  locationId: number;
  reservationId: string;
  totalPrice: number;
  subTotalPrice: number;
  currency: AVAILABLE_CURRENCIES;
  frequency: CLEANING_FREQUENCY;
  promoCode: string | "";
  duration: number;
  cleaningDate: string;
  userIdSHA256: string | "";
}

export interface PaymentDL {
  funnelStep: FUNNEL_STEP.PAYMENT;
  cleaningType: SERVICE_TYPE.HOME_CLEANING;
  locationId: number;
  contractId: string;
  reservationId: string;
  totalPrice: number;
  subTotalPrice: number;
  currency: AVAILABLE_CURRENCIES;
  frequency: CLEANING_FREQUENCY;
  promoCode: string | "";
  duration: number;
  cleaningDate: string;
  paymentMethod: PAYMENT_METHODS;
  userIdSHA256: string | "";
  emailSHA256: string;
  //   phoneSHA256: string;
}

export interface PurchaseDL {
  funnelStep: FUNNEL_STEP.PURCHASE;
  //   cleaningType: SERVICE_TYPE.HOME_CLEANING;
  contractId: string;
  paymentStatus: PAYMENT_STATUS;
  //   userIdSHA256: string | "";
}
